import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import API from '../api';
import { useTranslation } from 'react-i18next';
import './styles.css';

function isTokenUsable(token) {
  if (!token || typeof token !== 'string') return false;
  const parts = token.split('.');
  if (parts.length !== 3) return false;
  try {
    const payload = JSON.parse(window.atob(parts[1]));
    if (!payload || !payload.exp) return true;
    const nowSec = Math.floor(Date.now() / 1000);
    return payload.exp > nowSec;
  } catch (_) {
    return false;
  }
}

export default function Layout({ title, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [officeName, setOfficeName] = useState('Delivery Office');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!isTokenUsable(token)) {
      if (token) {
        localStorage.removeItem('token');
      }
      return;
    }

    API.get('profile/me/', { skipAuthRedirect: true })
      .then((res) => {
        if (res.data?.office_name) setOfficeName(res.data.office_name);
      })
      .catch(() => {});
  }, []);

  const navItems = [
    { path: '/', label: t('Dashboard'), icon: '📊' },
    { path: '/dispatch-board', label: t('Smart Dispatch Board'), icon: '🧭' },
    { path: '/orders', label: t('Orders'), icon: '📦' },
    { path: '/drivers', label: t('Drivers'), icon: '🚗' },
    { path: '/customers', label: t('Customers'), icon: '👥' },
    { path: '/tracking', label: t('Order Tracking'), icon: '🔎' },
  ];

  const changeLanguage = async (lang) => {
    localStorage.setItem('preferred_language', lang);
    await i18n.changeLanguage(lang);
    try {
      await API.post('profile/me/', { language: lang });
    } catch (_) {}
  };

  return (
    <div className={`app-shell ${i18n.language === 'ar' ? 'is-rtl' : 'is-ltr'}`}>
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="brand-icon">🚚</div>
          <div>
            <div className="brand-title">{officeName}</div>
            <div className="brand-sub">{t('Delivery Management')}</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
              type="button"
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="row-actions" style={{ marginBottom: 10 }}>
          <button className={`btn ${i18n.language === 'ar' ? 'btn-primary' : 'btn-secondary'}`} type="button" onClick={() => changeLanguage('ar')}>عربي</button>
          <button className={`btn ${i18n.language === 'fr' ? 'btn-primary' : 'btn-secondary'}`} type="button" onClick={() => changeLanguage('fr')}>FR</button>
          <button className={`btn ${i18n.language === 'en' ? 'btn-primary' : 'btn-secondary'}`} type="button" onClick={() => changeLanguage('en')}>EN</button>
        </div>

        <button
          className="btn btn-secondary sidebar-logout"
          onClick={() => {
            localStorage.removeItem('token');
            navigate('/login');
          }}
          type="button"
        >
          {t('Logout')}
        </button>
      </aside>

      <main className="main-content">
        <header className="page-header">
          <h1>{title}</h1>
        </header>
        {children}
      </main>
    </div>
  );
}
